import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsApi } from '../lib/api';
import { useAuth } from './AuthContext';

const SiteLockContext = createContext();

export const useSiteLock = () => {
    const context = useContext(SiteLockContext);
    if (!context) {
        throw new Error('useSiteLock must be used within a SiteLockProvider');
    }
    return context;
};

export const SiteLockProvider = ({ children }) => {
    const [lockedPages, setLockedPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const { isAdmin } = useAuth();

    useEffect(() => {
        loadSiteLockStatus();
    }, []);

    const loadSiteLockStatus = async () => {
        try {
            const response = await settingsApi.getSiteLock();
            setLockedPages(response.data.locked_pages || []);
        } catch (error) {
            console.error('Failed to load site lock status:', error);
        } finally {
            setLoading(false);
        }
    };

    const togglePageLock = async (page) => {
        try {
            const isCurrentlyLocked = lockedPages.includes(page);
            const response = await settingsApi.setSiteLock(page, !isCurrentlyLocked);
            setLockedPages(response.data.locked_pages || []);
            return !isCurrentlyLocked;
        } catch (error) {
            console.error('Failed to toggle page lock:', error);
            throw error;
        }
    };

    const isPageLocked = (page) => {
        if (isAdmin) return false;
        return lockedPages.includes(page);
    };

    const isPageLockedForAdmin = (page) => {
        return lockedPages.includes(page);
    };

    return (
        <SiteLockContext.Provider value={{ 
            lockedPages,
            loading, 
            togglePageLock,
            isPageLocked,
            isPageLockedForAdmin,
            refreshLockStatus: loadSiteLockStatus 
        }}>
            {children}
        </SiteLockContext.Provider>
    );
};
